/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./ExpandingDataCard.vue?vue&type=template&id=502ac240"
import script from "./ExpandingDataCard.vue?vue&type=script&lang=js"
export * from "./ExpandingDataCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports